import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {mapParseList, zNumberToString} from '@brunata-angular/util';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';
import {z} from 'zod';

export const customizedExportSuperTypeSchema = z.object({
    meterSuperTypeNo: zNumberToString,
});

export type CustomizedExportSuperType = z.infer<typeof customizedExportSuperTypeSchema>;

@Injectable({providedIn: 'root'})
export class MeterTypesService {
    private readonly baseUrl = environment.onlineServiceUrl;
    private readonly http = inject(HttpClient);

    getAvailableSuperTypes(): Observable<CustomizedExportSuperType[]> {
        return this.http
            .get(`${this.baseUrl}/customizedexports/supertypes`, {withCredentials: true})
            .pipe(mapParseList(customizedExportSuperTypeSchema));
    }
}
